export default __webpack_public_path__ + "static/media/home01.9948bd44.png";